import { render, staticRenderFns } from "./DecontareSettings.vue?vue&type=template&id=7d059dd7&scoped=true"
import script from "./DecontareSettings.vue?vue&type=script&lang=js"
export * from "./DecontareSettings.vue?vue&type=script&lang=js"
import style0 from "./DecontareSettings.vue?vue&type=style&index=0&id=7d059dd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d059dd7",
  null
  
)

export default component.exports